<template>
	<Modal v-model="showModal" hasCloseIcon hasDivider :closeOnMask="false">
		<div slot="header">编辑公式 - {{templateItem.title}}</div>
		<Row v-width="720" class="margin-top" type="flex" :space-x="20">
			<Cell class="label">{{formulaTargetTitle}}</Cell>
			<Cell>
				<DropdownCustom ref="dropdown" :toggleIcon="false" trigger="manual">
					<input v-width="150" type="text" v-model="kmFiler" @focus="$refs.dropdown.show()">
					<div style="min-width: 150px;" slot="content" class="voucher-select">
						<ul>
							<li v-for="v in voucherFilterSelect" :key="v.id" @click="doSelect(v)">
								{{v.subjectFullName || v.name}}
							</li>
						</ul>
					</div>
				</DropdownCustom>
			</Cell>
			<Cell class="label">运算符号</Cell>
			<Cell><Select v-model="form.calculation" dict="operation" placeholder="运算符号" v-width="100" :deletable="false"/></Cell>
			<template v-if="templateItem.sources == 0">
				<Cell class="label">取数规则</Cell>
				<Cell><Select v-model="form.accessRules" v-width="140" placeholder="取数规则" :dict="'accessRules'+type" :deletable="false"/></Cell>
			</template>
			<Cell>
				<Button color="primary" @click="addItem">添加</Button>
			</Cell>
		</Row>
		<Table class="margin-top" :datas="formulas" border>
			<TableItem :title="formulaTargetTitle">
				<template slot-scope="{data}">
					{{getFormulaTargetName(data.fromTag)}}
				</template>
			</TableItem>
			<TableItem title="运算符号" prop="calculation"/>
			<TableItem v-if="templateItem.sources == 0" title="取数规则" prop="accessRules" :dict="'accessRules'+type"/>
			<TableItem :width="100">
				<div class="actions" slot-scope="{data,index}">
					<span @click="removeItem(index)">删除</span>
				</div>
			</TableItem>
		</Table>
		<div slot="footer">
			<button class="h-btn" :loading="loading" @click="showModal=false">取消</button>
			<Button color="primary" :loading="loading" @click="save">保存</Button>
		</div>
	</Modal>
</template>

<script>
	export default {
		name: "TemplateItemFormulaModal",
		props: {
			templateItems: Array,
		},
		data() {
			return {
				showModal: false,
				loading: false,
				type: '0',
				kmFiler: '',
				voucherSelect: [],
				templateItem: {},
				form: {
					fromTag: null,
					calculation: '+',
					accessRules: '0',
				},
				formulas: []
			}
		},
		watch: {
			showModal(val) {
				if (!val) {
					this.kmFiler = "";
					this.$set(this.form, 'fromTag', null);
				}
			}
		},
		computed: {
			isCashFlowFormula() {
				return this.type == 2 && this.templateItem.sources == 0;
			},
			formulaTargetTitle() {
				if (this.templateItem.sources != 0) {
					return '项目名称';
				}
				return this.isCashFlowFormula ? '现金流项目' : '科目';
			},
			voucherSelectMap() {
				let map = {};
				this.voucherSelect.forEach(value => {
					map[value.id] = value;
				});
				return map;
			},
			voucherFilterSelect() {
				if (this.kmFiler) {
					let keyword = this.kmFiler.toLowerCase();
					return this.voucherSelect.filter(value => {
						return [value.code, value.name, value.mnemonicCode, value.subjectFullName].some(text => {
							return text && String(text).toLowerCase().indexOf(keyword) !== -1;
						});
					});
				}
				return this.voucherSelect;
			}
		},
		methods: {
			getFormulaTargetName(fromTag) {
				let target = this.voucherSelectMap[fromTag];
				return target ? target.name : '';
			},
			doSelect(v) {
				this.$set(this.form, 'fromTag', String(v.id));
				this.kmFiler = v.name;
				this.$refs.dropdown.hide();
			},
			toggle(templateItem, type) {
				this.templateItem = templateItem;
				this.type = type;
				this.formulas = Array.from(templateItem.formulas || []);
				this.$set(this.form, 'accessRules', type == 2 && templateItem.sources == 0 ? '1' : '0');
				this.showModal = !this.showModal;
				if (templateItem.sources === 0 && this.showModal) {
					this.loadFormulaSelect();
				} else {
					this.voucherSelect = this.templateItems.map(val => {
						return {
							id: val.id,
							name: val.title,
							subjectFullName: `(${val.lineNum})` + val.title,
							mnemonicCode: val.title,
							code: val.title
						};
					});
				}
			},
			save() {
				this.loading = false;
				Api.report.template.items.formula({
					formulas: this.formulas,
					templateItemsId: this.templateItem.id
				}).then(() => {
					this.showModal = false;
					this.$emit('success');
				}).finally(() => {
					this.loading = false;
				});
			},
			addItem() {
				if (this.form.fromTag) {
					if (this.formulas.find(value => value.fromTag === this.form.fromTag && value.calculation === this.form.calculation && value.accessRules === this.form.accessRules)) {
						this.$Message("已存在相同运算公式！");
						return
					}
					this.formulas.push(Object.assign({
						templateId: this.templateItem.templateId,
						templateItemsId: this.templateItem.id
					}, this.form));
					this.$set(this.form, 'fromTag', null);
					this.kmFiler = "";
				}
			},
			removeItem(idx) {
				this.formulas.splice(idx, 1);
			},
			loadFormulaSelect() {
				if (this.isCashFlowFormula) {
					this.loadCashFlowSelect();
				} else {
					this.loadVoucherSelect();
				}
			},
			loadVoucherSelect() {
				let tmp = localStorage.getItem('voucherSelectAll');
				if (tmp) {
					this.voucherSelect = JSON.parse(tmp);
				}
				Api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
					this.voucherSelect = data;
					localStorage.setItem("voucherSelectAll", JSON.stringify(data));
				});
			},
			loadCashFlowSelect() {
				Api.setting.accountingCategory.list().then(({data}) => {
					let cashFlowCategory = (data || []).find(item => item.name === '现金流');
					if (!cashFlowCategory) {
						this.voucherSelect = [];
						return;
					}
					Api.setting.accountingCategoryDetails.loadAuxiliaryAccountingData([cashFlowCategory]).then(({data}) => {
						let items = data[cashFlowCategory.id] || [];
						this.voucherSelect = items.map(item => {
							return {
								id: item.id,
								name: item.name,
								subjectFullName: (item.code ? `(${item.code})` : '') + item.name,
								mnemonicCode: item.cusColumn1 || item.name,
								code: item.code || item.name
							};
						});
					});
				});
			}
		},
	}
</script>

<style scoped lang="less">
	.voucher-select {
		max-height: 200px;
		overflow-y: auto;

		li {
			padding: 5px;
			cursor: pointer;

			&:hover {
				background-color: #dff7df;
			}
		}
	}
</style>